"use client";

import type { SoundEffectsListBlock } from "@mw/shared/payload-types";

import dynamic from "next/dynamic";

const AudioList = dynamic(() => import("./BlockAudioList").then(mod => mod.BlockAudioList));

export const BlockAudioListWrapper = (props: SoundEffectsListBlock) => {
  return <AudioList {...props} />;
};
